/* eslint-disable @angular-eslint/directive-selector */
import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
/**
 * Purpose of directive is to reset the form controls value back to 0 if
 * user enters a value greater than 100. This copies the functionality
 * of Clear 1. In order for this to work with PrimeNG, you must not utilize the
 * max input. Using max will reset value to max value if over.
 */
@Directive({ selector: '[cmgFormControlFactorReset]' })
export class CmgFormControlFactorResetDirective implements OnInit, OnDestroy {
  private readonly _ngControl = inject(NgControl);

  private _subscriptions = new Subscription();
  ngOnInit() {
    this._subscriptions.add(
      this._ngControl.control.valueChanges.subscribe((value) => {
        if (value > 100) {
          this._ngControl.control.setValue(0);
        }
      }),
    );
  }
  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
